import { Clock, Users, Sparkles, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { programs } from "../mock/mock";
import CTA from "../components/sections/CTA";
import { LearningDomainsInfographic, DailyScheduleInfographic } from "../components/infographics/ProgramsInfographics";

const ProgramsPage = () => {
  return (
    <div>
      <section className="pt-16 pb-16 bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm border border-orange-100 mb-4">
            <Sparkles className="w-4 h-4 text-orange-600" />
            <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">Our Programs</span>
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-stone-800 mb-4">
            Programs for Every <span className="text-orange-600">Little Star</span>
          </h1>
          <p className="text-stone-600 max-w-2xl mx-auto">
            Age-appropriate curriculums built around Sanatan values, play-based learning and holistic development.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 space-y-16">
          {programs.map((p, i) => (
            <div key={p.id} className="grid lg:grid-cols-2 gap-8 items-center">
              <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                <div className="relative">
                  <img src={p.image} alt={p.name} className="rounded-3xl shadow-xl w-full h-80 object-cover" />
                  <div className={`absolute -bottom-4 -right-4 ${p.accent} text-white rounded-2xl px-5 py-3 shadow-xl`}>
                    <p className="text-xs uppercase tracking-wider opacity-80">Age Group</p>
                    <p className="font-display font-bold text-lg">{p.ageGroup}</p>
                  </div>
                </div>
              </div>
              <div className={i % 2 === 1 ? "lg:order-1" : ""}>
                <div className={`inline-block ${p.color} px-4 py-1.5 rounded-full text-xs font-bold text-stone-700 uppercase tracking-wider mb-3`}>
                  Program
                </div>
                <h2 className="font-display text-3xl md:text-4xl font-bold text-stone-800 mb-4">{p.name}</h2>
                <p className="text-stone-600 leading-relaxed mb-5">{p.description}</p>
                <div className="flex gap-6 mb-5 text-sm">
                  <div className="flex items-center gap-1.5 text-stone-700">
                    <Users className="w-4 h-4 text-orange-600" />
                    <span className="font-semibold">{p.ageGroup}</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-stone-700">
                    <Clock className="w-4 h-4 text-orange-600" />
                    <span className="font-semibold">{p.duration}</span>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2 mb-6">
                  {p.highlights.map((h, j) => (
                    <div key={j} className="flex items-center gap-2 text-sm text-stone-700">
                      <div className="w-5 h-5 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                        <Check className="w-3 h-3 text-orange-700" />
                      </div>
                      <span>{h}</span>
                    </div>
                  ))}
                </div>
                <Link to="/admission">
                  <Button className="bg-gradient-to-r from-orange-600 to-amber-600 text-white rounded-full px-6 h-11 btn-shine">
                    Enroll in {p.name}
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <LearningDomainsInfographic />
      <DailyScheduleInfographic />

      <CTA />
    </div>
  );
};

export default ProgramsPage;
